import React from "react";
import "../style/footer.css";
import { ReactComponent as LogoShortTotalWhite } from "../mediaSvg/logoCompleteWhite.svg";

function Footer() {
  return (
    <footer className="footerContainer">
      <LogoShortTotalWhite className="logoFooter" />
      <p>Copyright&copy;2024 @ZabalaJackson. All Rights Reserved</p>
    </footer>
  );
}

export default Footer;
